module.exports = __webpack_public_path__ + "static/media/img23.6fb34c8b.jpg";